var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex d-lg-none justify-content-center swipe"},[_c('font-awesome-icon',{staticClass:"m-1 h2 left",attrs:{"icon":['far', 'arrow-left-long']}}),_vm._v(" "),_c('font-awesome-icon',{staticClass:"m-1 h2 hand",attrs:{"icon":['far', 'hand-point-up']}}),_vm._v(" "),_c('font-awesome-icon',{staticClass:"m-1 h2 right",attrs:{"icon":['far', 'arrow-right-long']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793eb78c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SwipeIcon.vue
// module id = dq8F
// module chunks = 1